module.exports = __webpack_public_path__ + "static/tiru-f466870a791367478f65ef4b0ad65e5e.jpg";